import type { BoardType } from "@/model/baseTypes";
import type { Board } from "@/model/board";

import { webEvent } from "./event";

interface BoardEvent {
  type: BoardType;
  id: Board["id"];
  artId: Board["artId"];
  teamId?: string;
  matchesUsersArt?: boolean;
  matchesUsersTeam?: boolean;
}
/**
 * Fired when a board is activated (equivalent to a pageview)
 * NOTE: This generally won't fire when switching between two boards
 *       of the same type, eg. from one team board to another
 */
export const boardActivated = ({
  type,
  id,
  teamId,
  artId,
  matchesUsersArt,
  matchesUsersTeam,
}: BoardEvent) =>
  webEvent("board", "activated", {
    toBoard: type,
    boardId: id,
    artId,
    teamId,
    matchesUsersArt,
    matchesUsersTeam,
  });

/**
 * Fired when a board is deactivated (ie. user is leaving the board)
 * NOTE: This generally won't fire when switching between two boards
 *       of the same type, eg. from one team board to another
 */
export const boardDeactivated = ({
  type,
  id,
  teamId,
  artId,
  matchesUsersArt,
  matchesUsersTeam,
}: BoardEvent) =>
  webEvent("board", "deactivated", {
    toBoard: type,
    boardId: id,
    artId,
    teamId,
    matchesUsersArt,
    matchesUsersTeam,
  });
